import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal, ModalBody,
} from 'reactstrap';

function TermsService(props) {
  const {
    isOpen, onClose,
  } = props;
  const [modal, setModal] = useState(isOpen);
  const toggle = () => {
    setModal(!modal);
    onClose();
  };
  const hideModal = () => {
    toggle();
    onClose();
  };

  return (
    <Modal isOpen={modal} className="modal-contract">
      <ModalBody>
        <div className="create-contract">
          <div className="create-contract-head">
            <div className="create-contract-head-container">
              <h1>
                BygMusic LLC
                <p className="mb-0">PITCH PROPOSAL AUTHORIZATION</p>
              </h1>
              <div className="create-contract-head-btn-group">
                <span onClick={hideModal} className="icon icon-cross m-0 p-0" />
              </div>
            </div>
          </div>
          <div className="create-contract-content pb-5">
            <div className="create-contract-content-container">
              <div className="create-contract-content-container-data static-page-data">
                <p>
                  This Services Agreement (the “Agreement”) is made and entered into by and between BygMusic,
                  LLC, a California limited liability company “Company”),  and (“Artist”). Company and Artist
                  are sometimes hereinafter referred to individually as “party” and collectively as “parties”.
                </p>
                <h4>RECITALS</h4>
                <p>
                  <strong>A.</strong>
                  Company provides a backend platform to collaborate on online/digital content, including web traffic,
                  offline sponsorships; digital media traffic and advertisement placements of music artists on a consolidated
                  basis to enhance monetization (“Services”).
                </p>
                <p>
                  <strong>B.</strong>
                  Artist is a music talent with a digital media presence and is interested Company including Artist in its pitches to potential sponsors.
                </p>
                <h4>OPERATIVE PROVISIONS</h4>
                <p>
                  <strong>1. Pitch.</strong>
                  Artist authorizes Company to utilize Artist’s image and social media links for the purpose of pitching Company’s
                  marketing and sponsorship opportunities, including but not limited to prospecting brands, advertising campaigns and sponsorships,
                  deployment and program strategies, account management and support for all brand advertisements and sponsor campaigns to be created
                  or sold by Company (“Campaigns”).
                </p>
                <p>
                  <strong>2. Potential Campaigns.</strong>
                  If Company desires to include Artist in a Campaign, Company shall submit the Campaign opportunity to Artist and
                  Artist shall have the right to approve or reject any proposed Campaign presented by Company to Artist. If Artist would like to proceed,
                  the parties will negotiate a Services Agreement with the terms and conditions of the Artist’s inclusion in the Campaign, including without
                  limitation compensation to be paid Artist as part of the Campaign. Notwithstanding anything herein to the contrary, Company has no obligation
                  to include Artist in any Campaign and Artist has no obligation to accept including in any Campaign.
                </p>
                <p>
                  <strong>3. Term of Agreement.</strong>
                  The initial term of this Agreement shall commence on the Effective Date and may be terminated by either party upon
                  thirty (30) days’ prior written notice. Upon termination, Company shall discontinue the use of Artist’s image and social media links.
                </p>

                <p>
                  <strong>4. Non-Circumvent.</strong>
                  As additional consideration for Company to enter into this Agreement, provided Artist does not have a pre-existing relationship
                  with a third party approached by Company for a Campaign, Artist agrees not to directly contact such third party which Company has approached for
                  a Campaign, and presented to Artist, for a period of twelve (12) months following the termination of this Agreement. If Artist implements a
                  Campaign or similar type of sponsorship with such third party, Company shall be entitled to compensation at a rate of fifty percent (50%)
                  of the gross revenues received by Artist related to the new campaign.
                </p>

                <p>
                  <strong>5. Trademark License/Image Release.</strong>
                  Company and Artist retain all right, title and interest in and to their respective trademarks,
                  service marks, service names and trade names worldwide. Artist grants Company a non-exclusive, non-transferrable, worldwide, royalty-free
                  license to use, publish and reference its’ image, likeness, trademarks, service royalty-free license to use, publish and reference its’
                  image, likeness, trademarks, service marks and trade names worldwide, in connection with Company making a pitch as set forth in this
                  Agreement and related to Company’s marketing of its services in connection therewith.
                </p>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

TermsService.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default TermsService;
